import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ServiceNearDashboardComponent } from './service-near-dashboard/service-near-dashboard.component';
import { ServiceDetailsComponent } from './service-details/service-details.component';
import { AuthGuardGuard } from 'src/app/Authentication/auth-guard.guard';
import { ServiceAddComponent } from './service-add/service-add.component';
import { ServiceNearMoreMenulistComponent } from './service-near-more-menulist/service-near-more-menulist.component';
import { ServiceNearContactUsComponent } from './service-near-contact-us/service-near-contact-us.component';
import { ServiceNearPayinComponent } from './service-near-payin/service-near-payin.component';
import { ServiceListComponent } from './service-list/service-list.component';
import { ShopReportComponent } from './shop-report/shop-report.component';
import { WhatsNewComponent } from './whats-new/whats-new.component';
import { SalesListComponent } from './sales-list/sales-list.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AccountInfoComponent } from './account-info/account-info.component';
import { ServicenearProfileComponent } from './servicenear-profile/servicenear-profile.component';
import { ServicenearSuperadminComponent } from './servicenear-superadmin/servicenear-superadmin.component';
import { ServicenearSellersDetailsComponent } from './servicenear-sellers-details/servicenear-sellers-details.component';
import { ServiceProductListComponent } from './service-product-list/service-product-list.component';
import { ServicenearSettingsComponent } from './servicenear-settings/servicenear-settings.component';
import { ServicenearSocialProfilesComponent } from './servicenear-social-profiles/servicenear-social-profiles.component';
import { ServicenearMyOtherDevicesComponent } from './servicenear-my-other-devices/servicenear-my-other-devices.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    component: ServiceNearDashboardComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'serviceDetails',
    component: ServiceDetailsComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'serviceAdd/:jobtype',
    component: ServiceAddComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'serviceAdd',
    component: ServiceAddComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'moreMenuList',
    component: ServiceNearMoreMenulistComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'contactUs',
    component: ServiceNearContactUsComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'payin',
    component: ServiceNearPayinComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'serviceList',
    component: ServiceListComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'shopreport',
    component: ShopReportComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'whatsnew',
    component: WhatsNewComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'saleslist',
    component: SalesListComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'changePassword',
    component: ChangePasswordComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'accountInfo',
    component: AccountInfoComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'profile',
    component: ServicenearProfileComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'superadmin',
    component: ServicenearSuperadminComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'sellersDetails/:branchID',
    component: ServicenearSellersDetailsComponent,
    canActivate: [AuthGuardGuard],
  },
  { 
    path: 'serviceProductList',
    component: ServiceProductListComponent,
    canActivate: [AuthGuardGuard],
  },
  { 
    path: 'settings',
    component: ServicenearSettingsComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'socialProfiles',
    component: ServicenearSocialProfilesComponent,
    canActivate: [AuthGuardGuard],
  },
  {
    path: 'myOtherDevices',
    component: ServicenearMyOtherDevicesComponent,
    canActivate: [AuthGuardGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceNearRoutingModule {}
